<div
  class="module-card"
  [class.disabled]="data?.disabled"
  (click)="onCardClick()"
  (keydown)="onCardKeydown($event)"
  role="button"
  tabindex="0">
  <div class="module-title">{{ title }}</div>
  <img *ngIf="imageSrc" class="module-icon" [src]="imageSrc" [alt]="title || 'module icon'" />
</div>
